var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclaimatorySign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.866 3.5L19.7942 15.5C20.1791 16.1667 19.698 17 18.9282 17H5.0718C4.302 17 3.82087 16.1667 4.20577 15.5L11.134 3.5C11.5189 2.83333 12.4811 2.83333 12.866 3.5Z",
    stroke: "#727272",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_913_22335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5002C12.5523 15.5002 13 15.0525 13 14.5002C13 13.948 12.5523 13.5002 12 13.5002C11.4477 13.5002 11 13.948 11 14.5002C11 15.0525 11.4477 15.5002 12 15.5002Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.50024H13V12.5002H11V6.50024Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_913_22335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 5.00024)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimatorySign);
export default __webpack_public_path__ + "static/media/exclaimatory-sign.5f28361965f6a37de5116aa1d85d7c3c.svg";
export { ForwardRef as ReactComponent };